import { render } from "./index.vue?vue&type=template&id=cbb1b960&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cbb1b960&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb1b960"],['__file',"src/views/Home/Promotion/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cbb1b960"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cbb1b960', __exports__)) {
    console.log('reload')
    api.reload('cbb1b960', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=cbb1b960&scoped=true", () => {
    console.log('re-render')
    api.rerender('cbb1b960', render)
  })

}


export default __exports__